
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Text } from 'vcc-ui';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "new-minor-version-11"
    }}>{`New Minor Version: 1.1`}</h1>
    <p>{`After a long and relaxing summer we're finally back in action. To start things off we're releasing a new minor version packed with new functionality: VCC UI 1.1.`}</p>
    <h2 {...{
      "id": "new-components"
    }}>{`New Components`}</h2>
    <p>{`The most notable addition in this release are the new components:`}</p>
    <h3 {...{
      "id": "text-component"
    }}>{`Text Component`}</h3>
    <p>{`Typography has been a source of major brand inconsistency in our digital products. As a result a `}<inlineCode parentName="p">{`<Text>`}</inlineCode>{` component has been one of the most requested feature for a while now. We've worked closely together with the Design System team to deliver this.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`<Text>`}</inlineCode>{` component will allow you to select from a number of text styles
that are aligned with the upcoming Volvo Cars Design System. The text component
also has a baseline grid setting implemented which will create a perfect
vertical rhythm on your page.`}</p>
    <p>{`Live Demo:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<>
  <Text variant="cook">The quick brown fox jumps over the lazy dog</Text>
  <Text variant="hillary">The quick brown fox jumps over the lazy dog</Text>
  <Text variant="columbus">The quick brown fox jumps over the lazy dog</Text>
</>
`}</code></pre>
    <p>{`Head over to the `}<a parentName="p" {...{
        "href": "/docs/components/text"
      }}>{`Text component documentation`}</a>{` for a full disclosure!`}</p>
    <h3 {...{
      "id": "spacer-component"
    }}>{`Spacer Component`}</h3>
    <p>{`Another source of inconsistency has been the use of space (eg.
margins and paddings). To deal with this, we're introducing a `}<strong parentName="p">{`modular grid`}</strong>{` and a `}<inlineCode parentName="p">{`<Spacer>`}</inlineCode>{` component.`}</p>
    <p>{`On the web, the modular grid is simply a multiple of 8 pixels (macro grid size). You can also multiply with 0.5 points to adjust to a "micro grid size", eg. 4 pixels.
The default spacer size is 1, but can be changed via the `}<em parentName="p">{`size`}</em>{` property.`}</p>
    <p><img parentName="p" {...{
        "src": "/blog/modular-grid.png",
        "alt": "Modular Grid"
      }}></img></p>
    <p>{`Live Demo:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex extend={{ flexDirection: 'row' }}>
  <Button intent="primary">Primary</Button>
  <Spacer />
  <Button intent="secondary">Secondary</Button>
  <Spacer size={4} />
  <Button intent="destructive">Destructive</Button>
</Flex>
`}</code></pre>
    <p>{`Since we are using flex-basis to apply the space, it's directionally independent. `}<strong parentName="p">{`Try changing `}<inlineCode parentName="strong">{`flexDirection`}</inlineCode>{` to column`}</strong>{` and you'll see that the space is applied according to the directional flow of the components. Check out the `}<a parentName="p" {...{
        "href": "/docs/components/spacer"
      }}>{`Spacer component documentation`}</a>{` for more!`}</p>
    <h3 {...{
      "id": "styletags-component"
    }}>{`StyleTags Component`}</h3>
    <p>{`Server Side Rendering just became a lot easier. Instead of creating your own
`}<inlineCode parentName="p">{`<style>`}</inlineCode>{` tags and injecting them into `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` you can now just use the StyleTags
component to achieve the same thing.`}</p>
    <pre><code parentName="pre" {...{}}>{`<head>
  <StyleTags renderer={this.props.renderer} />
</head>
`}</code></pre>
    <p>{`We're already implemented it on this site, checkout `}<a parentName="p" {...{
        "href": "https://github.com/volvo-cars/vcc-ui-website/commit/22530214989a4f81033febb5dfde4bffcc4e56b9"
      }}>{`the
diff`}</a>{` to see how it's done.`}</p>
    <h2 {...{
      "id": "notable-changes"
    }}>{`Notable Changes`}</h2>
    <p>{`Apart from new components, we also have a few other noteable changes and
improvements in this version:`}</p>
    <h3 {...{
      "id": "refactor-tabnav-component"
    }}>{`Refactor TabNav component`}</h3>
    <p>{`We've introduced a new simpler API (backwards compatible)`}</p>
    <ul>
      <li parentName="ul">{`Removed react-transition-group as a peer dependency`}</li>
      <li parentName="ul">{`You can now pass your own sticky elements (not just back button)`}</li>
    </ul>
    <h3 {...{
      "id": "renamed-box-to-flex"
    }}>{`Renamed Box to Flex`}</h3>
    <p>{`We've deprecated the Box component, it has simply been renamed to Flex, in order to
align with the future naming conventions of VCC UI 2.0 core components.`}</p>
    <h3 {...{
      "id": "other-improvements-and-fixes"
    }}>{`Other improvements and fixes:`}</h3>
    <ul>
      <li parentName="ul">{`Renamed the altText prop on `}<inlineCode parentName="li">{`<Logo>`}</inlineCode>{` to alt (#246)`}</li>
      <li parentName="ul">{`Fix incorrect documentation and prop types for `}<inlineCode parentName="li">{`<Click>`}</inlineCode>{` component`}</li>
      <li parentName="ul">{`Add rel=noopener to `}<inlineCode parentName="li">{`<Link>`}</inlineCode>{` and `}<inlineCode parentName="li">{`<Click>`}</inlineCode>{` components with target=`}{`_`}{`blank`}</li>
      <li parentName="ul">{`Refactor class components to be function components with hooks`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;